import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MenuItemBaseComponent } from '../menu-item-base/menu-item-base.component';
import { Restaurant } from '../../../../core/models';
import { ConfigService } from '../../../../core/services/config.service';
import { MenuItemControlButtonComponent } from "../menu-item/menu-item-control-button/menu-item-control-button.component";
import { PricePipe } from "../../../../core/pipes/price.pipe";
import { ReadMoreComponent } from "../../../../common/read-more/read-more.component";
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';

@Component({
    selector: 'app-menu-item-with-image',
    templateUrl: './menu-item-with-image.component.html',
    styleUrls: ['./menu-item-with-image.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        NgbTooltipModule,
        TranslocoCurrencyPipe,
        PricePipe,
        MenuItemControlButtonComponent,
        ReadMoreComponent
    ]
})
export class MenuItemWithImageComponent extends MenuItemBaseComponent implements OnInit {

    @Input() restaurant: Restaurant
    @Input() restaurantCssClass: string = ''
    @Input() productStyle;

    readonly MOBILE_THRESHOLD = 700;
    isMobile: boolean = false;

    constructor(public translate: TranslocoService,
        public configService: ConfigService) {
        super(translate, configService)
    }

    ngOnInit(): void {
        super.ngOnInit()
        this.isMobile = window.innerWidth < this.MOBILE_THRESHOLD
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.isMobile = window.innerWidth < this.MOBILE_THRESHOLD
    }

}
